import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { HeaderAuthActions } from "@/components/Layout/header/HeaderAuthActions";
import { HeaderNavigation } from "@/components/Layout/header/HeaderNavigation";
import { HeaderPreferenceControls } from "@/components/Layout/header/HeaderPreferenceControls";
import { HEADER_MOBILE_MENU_ID } from "@/components/Layout/header/HeaderMobileToggle";
import "./HeaderMobileMenu.css";

interface HeaderMobileMenuProps {
  onNavigate: () => void;
}

export const HeaderMobileMenu = forwardRef<
  HTMLDivElement,
  HeaderMobileMenuProps
>(({ onNavigate }, ref) => {
  const { t } = useTranslation();

  return (
    <div
      ref={ref}
      className="site-header__mobile-menu"
      id={HEADER_MOBILE_MENU_ID}
      role="dialog"
      aria-modal="true"
      aria-label={t("a11y.mobileNav")}
    >
      <div className="site-header__mobile-content">
        <nav
          className="site-header__mobile-nav"
          aria-label={t("a11y.mobileNav")}
        >
          <HeaderNavigation variant="mobile" onNavigate={onNavigate} />
        </nav>
        <div className="site-header__mobile-buttons">
          <HeaderAuthActions size="lg" onNavigate={onNavigate} />
        </div>
        <div className="site-header__mobile-actions">
          <HeaderPreferenceControls variant="mobile" />
        </div>
      </div>
    </div>
  );
});

HeaderMobileMenu.displayName = "HeaderMobileMenu";
